export default {
  navbar: {
    home: 'Inicio',
    jobs: 'Empleos',
    companies: 'Empresas',
    about: 'Sobre nosotros',
    customerService: 'Servicio al cliente',
    signIn: 'Iniciar sesión',
    register: 'Registrarse'
  },
  customerService: {
    title: 'Contactar con servicio al cliente',
    subtitle: 'Nuestro equipo de soporte profesional está siempre disponible para responder sus preguntas las 24 horas.',
    onlineService: 'Servicio en línea',
    serviceDescription: 'Nuestro equipo de soporte profesional está siempre disponible para ayudarte las 24 horas.',
    startChat: 'Iniciar chat en línea',
    responseTime: 'Tiempo promedio de respuesta: 30 segundos',
    instantResponse: 'Respuesta instantánea',
    instantResponseDesc: 'Nuestro equipo de servicio al cliente está en línea las 24 horas, con un tiempo de respuesta promedio inferior a 2 minutos',
    professionalTeam: 'Equipo profesional',
    professionalTeamDesc: 'Personal de servicio al cliente capacitado rigurosamente y familiarizado con todos los procesos comerciales',
    securityPrivacy: 'Seguridad y privacidad',
    securityPrivacyDesc: 'Toda su información está encriptada para garantizar la seguridad absoluta',
    serviceOnline: 'Servicio en línea',
    seniorConsultant: 'Consultor senior de clientes'
  },
  home: {
    heroTitle: 'Encuentra tu trabajo ideal en la industria del cine',
    heroSubtitle: 'Conecta con los mejores cines y empresas de entretenimiento. Empieza tu viaje en el emocionante mundo del cine hoy mismo.',
    popularCategories: 'Categorías populares de empleos',
    categoriesDescription: 'Explora oportunidades en diferentes áreas del cine y entretenimiento',
    featuredJobOpportunities: 'Oportunidades de empleo destacadas',
    discoverLatestOpenings: 'Descubre las últimas vacantes en los mejores cines',
    openPositions: 'vacantes disponibles',
    quickApply: 'Aplicación rápida',
    whyChooseUs: 'Por qué elegirnos',
    joinLargestNetwork: 'Únete a la mayor red de profesionales del cine',
    categories: {
      theaterOperations: {
        title: 'Operaciones de cine',
        description: 'Gestionar las operaciones diarias del cine y asegurar proyecciones fluidas'
      },
      boxOfficeManagement: {
        title: 'Gestión de taquilla',
        description: 'Manejar la venta de entradas y servicio al cliente en taquilla'
      },
      cinemaTechnology: {
        title: 'Tecnología de cine',
        description: 'Mantener y operar equipos y sistemas de cine avanzados'
      },
      customerService: {
        title: 'Servicio al cliente',
        description: 'Ofrecer servicio excepcional a la audiencia del cine'
      },
      foodBeverage: {
        title: 'Alimentos y bebidas',
        description: 'Gestionar la operación del puesto de comidas y servicios de alimentos'
      },
      marketingPromotions: {
        title: 'Marketing y promociones',
        description: 'Crear y ejecutar estrategias de marketing para cines'
      }
    },
    featuredJobs: {
      theaterManager: {
        title: 'Gerente de cine',
        company: 'AMC Theatres',
        location: 'Nueva York, NY',
        type: 'Tiempo completo',
        salary: '$65K - $85K',
        benefit: 'Beneficios'
      },
      digitalProjectionist: {
        title: 'Proyectista digital',
        company: 'Regal Cinemas',
        location: 'Los Ángeles, CA',
        type: 'Tiempo completo',
        salary: '$45K - $60K',
        benefit: 'Capacitación'
      },
      marketingCoordinator: {
        title: 'Coordinador de marketing',
        company: 'Cinemark',
        location: 'Chicago, IL',
        type: 'Tiempo completo',
        salary: '$50K - $65K',
        benefit: 'Remoto'
      }
    },
    features: {
      largeIndustryNetwork: {
        title: 'Gran red industrial',
        description: 'Conecta con más de 2,500 cines y empresas de entretenimiento en todo el mundo',
        stat: 'Más de 15,000 usuarios activos'
      },
      verifiedEmployers: {
        title: 'Empleadores verificados',
        description: 'Todos los empleadores son revisados rigurosamente para garantizar oportunidades reales',
        stat: '100% empresas verificadas'
      },
      careerGrowth: {
        title: 'Crecimiento profesional',
        description: 'Accede a recursos de capacitación y oportunidades de ascenso',
        stat: '89% de éxito'
      }
    }
  },
  jobs: {
    heroTitle: 'Únete a nuestra familia cinematográfica',
    heroSubtitle: 'Sé parte de la magia que hace que las historias cobren vida. Buscamos personas apasionadas para unirse a nuestro equipo en crecimiento.',
    viewPositions: 'Ver vacantes disponibles',
    currentOpenings: 'Vacantes actuales',
    department: 'Departamento',
    location: 'Ubicación',
    applyNow: 'Aplicar ahora',
    whyJoinUs: 'Por qué unirte a nosotros',
    ourCulture: 'Nuestra cultura',
    applicationProcess: 'Proceso de postulación',
    startYourJourney: 'Empieza tu viaje',
    benefits: {
      freeMovieAccess: {
        title: 'Películas gratuitas',
        description: 'Disfruta de películas gratuitas ilimitadas para ti y tu familia.'
      },
      careerGrowth: {
        title: 'Desarrollo profesional',
        description: 'Capacitación completa y rutas claras de ascenso profesional.'
      },
      flexibleSchedule: {
        title: 'Horario flexible',
        description: 'Opciones de horario flexible para balancear trabajo y vida.'
      }
    },
    jobList: [
      {
        title: 'Gerente de operaciones de cine',
        location: 'Nueva York, NY',
        type: 'Tiempo completo',
        description: 'Liderar las operaciones diarias del cine, asegurando que nuestra ubicación emblemática brinde un servicio al cliente excepcional.'
      },
      {
        title: 'Proyectista digital senior',
        location: 'Los Ángeles, CA',
        type: 'Tiempo completo',
        description: 'Operar y mantener sistemas de proyección digital para garantizar la mejor experiencia de visualización.'
      },
      {
        title: 'Jefe de equipo de puesto de comidas',
        location: 'Chicago, IL',
        type: 'Tiempo completo',
        description: 'Gestionar las operaciones del puesto de comidas y liderar un equipo profesional de servicio de alimentos.'
      },
      {
        title: 'Especialista en experiencia del cliente',
        location: 'Miami, FL',
        type: 'Medio tiempo',
        description: 'Ofrecer servicio excepcional y crear experiencias inolvidables para nuestros huéspedes.'
      },
      {
        title: 'Especialista en soporte técnico',
        location: 'Seattle, WA',
        type: 'Tiempo completo',
        description: 'Mantener y solucionar problemas con equipos y sistemas de cine.'
      },
      {
        title: 'Coordinador de eventos',
        location: 'Boston, MA',
        type: 'Tiempo completo',
        description: 'Planificar y ejecutar proyecciones especiales y eventos privados de cine.'
      }
    ],
    testimonials: [
      {
        name: 'Emily Richardson',
        position: 'Gerente de cine',
        quote: 'Trabajar aquí ha sido un viaje increíble. Las oportunidades de crecimiento y el entorno de apoyo hacen que esto sea mucho más que un trabajo.'
      },
      {
        name: 'Michael Anderson',
        position: 'Proyectista digital senior',
        quote: 'La tecnología y el equipo con el que trabajamos son de primera categoría. Para cualquier amante del cine, esto es un sueño hecho realidad.'
      },
      {
        name: 'Sarah Martinez',
        position: 'Coordinador de eventos',
        quote: 'El trabajo en equipo aquí es increíble. Trabajamos juntos para crear experiencias memorables para nuestros huéspedes.'
      }
    ],
    applicationSteps: [
      {
        title: 'Aplicar en línea',
        description: 'Envía tu solicitud a través de nuestro portal de carreras.'
      },
      {
        title: 'Revisión inicial',
        description: 'Nuestro equipo revisará tu solicitud en 48 horas.'
      },
      {
        title: 'Entrevista',
        description: 'Reúnete con nuestro equipo para hablar sobre la oportunidad.'
      },
      {
        title: 'Bienvenido a bordo',
        description: 'Empieza tu viaje con nuestra familia cinematográfica.'
      }
    ]
  },
  companies: {
    searchPlaceholder: 'Buscar empresas...',
    location: 'Ubicación',
    companySize: 'Tamaño de la empresa',
    industry: 'Industria',
    openPositions: 'vacantes disponibles',
    viewJobs: 'Ver empleos',
    loadMore: 'Cargar más empresas',
    companyList: [
      {
        name: 'Universal Entertainment Group',
        location: 'Los Ángeles, CA',
        size: 'Más de 5,000 empleados',
        description: 'Empresa de entretenimiento global líder que produce y distribuye contenido cinematográfico y televisivo en todo el mundo.'
      },
      {
        name: 'Cinemark Productions',
        location: 'Nueva York, NY',
        size: '2,000-5,000 empleados',
        description: 'Estudio de producción galardonado especializado en películas de gran presupuesto y contenido digital innovador.'
      },
      {
        name: 'Digital Cinema Solutions',
        location: 'San Francisco, CA',
        size: '1,000-2,000 empleados',
        description: 'Empresa impulsada por la tecnología que revoluciona la experiencia cinematográfica digital a través de soluciones innovadoras.'
      },
      {
        name: 'Paramount Digital Studios',
        location: 'Chicago, IL',
        size: '500-1,000 empleados',
        description: 'Creando experiencias de entretenimiento digital de próxima generación a través de tecnología de vanguardia.'
      },
      {
        name: 'Global Theater Networks',
        location: 'Miami, FL',
        size: '1,000-2,000 empleados',
        description: 'Operando cadenas de cines de primera categoría con instalaciones de última generación en grandes ciudades.'
      },
      {
        name: 'Silverscreen Technologies',
        location: 'Seattle, WA',
        size: '500-1,000 empleados',
        description: 'Desarrollando soluciones de software de vanguardia para la industria cinematográfica moderna.'
      }
    ]
  },
  about: {
    heroTitle: 'Sobre nosotros',
    heroSubtitle: 'Donde la creatividad se encuentra con la tecnología, las historias cobran vida a través de lentes innovadores.',
    ourStory: 'Nuestra historia',
    storyParagraph1: 'CineMaster Studio fue fundada en 2010 y ha estado a la vanguardia de la innovación cinematográfica durante más de una década. Nuestro viaje comenzó con una visión simple pero poderosa: crear historias visuales convincentes que resuenen con audiencias de todo el mundo.',
    storyParagraph2: 'Hoy, estamos orgullosos de ser uno de los estudios de producción líderes, colaborando con marcas globales y artistas talentosos de la industria. Nuestro compromiso con la excelencia y la pasión por contar historias continúan impulsándonos hacia adelante.',
    ourCoreValues: 'Nuestros valores fundamentales',
    creativeExcellence: 'Excelencia creativa',
    creativeExcellenceDesc: 'Empujar los límites y establecer nuevos estándares en la narrativa visual.',
    collaborativeSpirit: 'Espíritu colaborativo',
    collaborativeSpiritDesc: 'Trabajar juntos para dar vida a visiones únicas.',
    qualityFirst: 'Calidad primero',
    qualityFirstDesc: 'Buscar la excelencia en cada cuadro que creamos.',
    meetOurTeam: 'Conoce a nuestro equipo',
    creativeDirector: 'Director creativo',
    leadCinematographer: 'Director de fotografía principal',
    technicalDirector: 'Director técnico',
    productionManager: 'Gerente de producción',
    yearsExperience: 'años de experiencia',
    projectsCompleted: 'proyectos completados',
    industryAwards: 'premios de la industria',
    happyClients: 'clientes felices'
  },
  footer: {
    copyright: '© 2025 TJH - Ticket Job Hub. Todos los derechos reservados.',
    description: 'Conectando talento con oportunidades en la industria del cine. Encuentra tu próximo papel en operaciones de cine, gestión o puestos técnicos.',
    quickLinks: 'Enlaces rápidos',
    jobSeeker: 'Buscador de empleo',
    newsletter: 'Boletín',
    newsletterText: 'Suscríbete para recibir las últimas actualizaciones de empleos y consejos profesionales.',
    emailPlaceholder: 'Tu correo electrónico',
    subscribe: 'Suscribirse',
    quickLinksList: ['Sobre nosotros', 'Contáctanos', 'Política de privacidad', 'Términos de servicio'],
    jobSeekerLinksList: ['Explorar empleos', 'Recursos profesionales', 'Consejos de CV', 'Alertas de empleos']
  }
}